import React, { Component } from 'react';
import T from 'prop-types';
// components
import { withRouter } from 'react-router-dom';
import Popover from '../../../components/Popover/Popover';
import Button from '../../../components/Button/Button';
import ModuleInclude from '../../../components/ModuleInclude/ModuleInclude';
// styles
import styles from './ModulePopover.mod.css';

class ModulePopover extends Component {
  handleClick = () => {
    const { history, moduleIndex } = this.props;
    history.push(`/module/${moduleIndex}`);
  };

  getActionButton = () => {
    const { state, isClient } = this.props;
    if (!isClient) {
      return null;
    }
    return (
      <div className={styles.action}>
        {state === 'current' && (
          <Button onClick={this.handleClick} primary>
            Continue
          </Button>
        )}
        {state === 'complete' && (
          <span onClick={this.handleClick} className={styles.redoLink}>
            Redo Module
          </span>
        )}
        {state === 'extra' && (
          <Button onClick={this.handleClick} primary>
            Continue
          </Button>
        )}
        {state === 'incomplete' && <Button>Locked</Button>}
      </div>
    );
  };

  render() {
    const { module, state, children, ...otherProps } = this.props;
    const { title, description } = module;

    const popoverBody = (
      <div className={styles.wrapper}>
        <h2 className={styles.heading}>{title}</h2>
        <p>{description}</p>
        <div className="semibold mb-5">Module Include</div>
        <div className={styles.footer}>
          <ModuleInclude module={module} />
          {this.getActionButton()}
        </div>
        {state === 'incomplete' && <div className={styles.locked} />}
      </div>
    );

    return (
      <Popover body={popoverBody} trigger="click" {...otherProps}>
        {children}
      </Popover>
    );
  }
}

ModulePopover.propTypes = {
  className: T.string,
  state: T.oneOf(['incomplete', 'complete', 'current', 'extra']),
  children: T.oneOfType([T.node, T.element]).isRequired,
  moduleIndex: T.string.isRequired,
  isClient: T.bool,
  module: T.shape({
    id: T.number.isRequired,
    title: T.string.isRequired,
    description: T.string.isRequired
  })
};

export default withRouter(ModulePopover);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/ModulePopover.jsx